// extracted by mini-css-extract-plugin
module.exports = {"ProductList":"ProductList_ProductList__wsmqz","ef-box":"ProductList_ef-box__UJ_7U"};